import React, { useEffect, useRef, useState } from "react";
import { BASE_URL } from "../../../global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddIcon from "@mui/icons-material/Add";
import { ClassicTable } from "../../../utils/components/Styles";
import {
  Grid,
  Paper,
  TextField,
  Typography,
  Autocomplete,
  Checkbox,
  Toolbar,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  Box,
  FormControlLabel,
  TableContainer,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import HelpIcon from "@mui/icons-material/Help";
import { styled } from "@mui/material/styles";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import { useLocation, useParams } from "react-router";
import DisplayTable from "./displayTable";
import { createInstrumentGuide } from "./guide";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import { allSettings } from "../../../utils/components/allSettings";
import ErrorModal from "../../../utils/components/errorModal";
import EditWrap from "../../commonComponent/editWrap";
import { fixedColumns, gaugeArr, parameters, mode, paratype, otherParamter } from "../../../constants/masterInstrumentConstants";
import { fetchDeciplineData, fetchInstrumentData, fetchStandardsData, fetchSupportiveData, fetchUncertinityData, getDateDistinct, getUnitMasterArray } from "./fetchHandler";
import { getFormattedDates } from "../../../utils/utils";
import { onSubmit } from "./submitHandler";


const VisuallyHiddenInput = styled("input")`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

const CreateInstrument = (props) => {
  const createInstrumentGuides = createInstrumentGuide();
  const [state, setState2] = useState({
    standards: [],
    filteredStandards: [],
    disciplineValue: {},
    uncertaintyMasterData: [],
    units: [],
    finalUnitArray: [],
    disciplines: [],
    disciplineArr: [],
    disciplineId: null,
    instrumentNameId: null,
    calibrationProcedureNo: null,
    referenceStandards: null,
    subGroup: null,
    tablePartition: null,
    sopUpload: null,
    standardMaster: null,
    supportiveIds: null,
    uncertaintyMaster: [],
    standardMasterIdArray: null,
    updateEnableDisableO: null,
    readingRows: [],
    readingRangeValue: [],
    et: true,
    readingColumns: fixedColumns,
    supportive: null,
    formatNumber: "",
    revisionNumber: "",
    revisionDate: "",
    datasheetFormatNumber: "",
    DatasheetRevisionNumber: "",
    DatasheetRevisionDate: "",
  });
  const [delteRangesID, setdelteRangesID] = useState([]);  
  const params = useParams();
  const [page, setPage] = useState(0);
  const [totalRows, setTotalRows] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [accreditationOptions, setAccreditationOptions] = useState([]);
  const [accreditationType, setAccreditationType] = useState(1);
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [remarksData, setRemarksData] = useState([]);
  const[commonUncertaintyFactors,setCommonUncertaintyFactors] = useState([]);
  const [tablePartitionSetting, settablePartitionSetting] = useState("");
  const [ISsopUpload, setIssopUpload] = React.useState(false);
  const [editAccess, setEditAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));

  const [dateRange, setDateRange] = useState([]);
  const [originalRange, setOriginalRange] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState({
    selectedFrom: '',
    selectedTo: '',
  });
  const [renewalNewDate, setRenewalDate] = useState(false);
  const [newRenewalDate, setnewRenewalDate] = useState(false);
  const disabledButtonDue = new Date(selectedDateRange.selectedTo) < new Date(); 
  const location = useLocation();
  const containerRef = useRef(null);
  const searchParams = new URLSearchParams(location.search);
  const scrollTo = searchParams.get("scrollTo");
  const openErrorModal = (errorMessage,stackTrace,fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  const setState = (val) => {
    setState2({
      ...state,
      ...val,
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  

  const filterStandardsByDiscipline = (inpt, dsid) => {
    if (dsid) return inpt.filter((e) => e.disciplineId === dsid);
    return inpt;
  };

  const retErr = (errTxt, err) => {
    console.log(errTxt, err);
    return "err";
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const data = new FormData();
    data.append("fileToUpload", file);

    axiosWithToken
      .post(BASE_URL + `fileUpload/fileUpload.php`, data)
      .then((res) => {
        if (res.status === 200) {
          setState({
            sopUpload: res.data,
          });
          toast.success("File Uploaded Successfully!");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getData = () => {
    Promise.all(
      [
        fetchDeciplineData(),
        fetchStandardsData(),
        fetchSupportiveData(),
        fetchUncertinityData(),
        getUnitMasterArray(),
      ].concat(params.id ? [fetchInstrumentData(params)] : [])
    )
      .then((res) => {
        let disciplineArr = [];
        for (var i = 0; i < res[0].length; i++) {
          disciplineArr.push({
            label: res[0][i].name,
            id: res[0][i].id,
          });
        }
        let st = {
          disciplines: res[0],
          disciplineArr: disciplineArr,
          standards: res[1],
          filteredStandards: res[1],
          supportive: res[2].map((item) => {
            return {
              id: item.pl_id,
              standardRangesId: item.pr_id,
              title: item.pl_standardName,
              range: item.pr_rangeName,
            };
          }),
          uncertaintyMasterData: res[3],
          units: res[4],
        };
        if (params.id) {
          let instr = { ...res[5] };
          setCommonUncertaintyFactors(instr?.inst_commonUncertaintyFactors?.split(","))
          // setAccreditationType(instr?.inst_accreditationType)
          let sim = [[], []];
          (instr.inst_supportiveInstrumentMasterData || "")
            .split(",")
            .map((e) => {
              sim[0].push(parseInt(e.split(":")[0]));
              sim[1].push(parseInt(e.split(":")[1]));
            });

          let disciplineKeys = false;
          st.disciplines.forEach((el) => {
            if (el.id == instr.ds_id) {
              if (el.disciplineKey == "0") {
                disciplineKeys = true;
              }
            }
          });
          if (disciplineKeys) {
            st.et = false;
          } else {
            st.et = true;
          }
          const unitArr = [""];
          for (let i = 0; i < st.units.length; i++) {
            if (parseInt(instr.ds_id) == st.units[i].disciplineId) {
              unitArr.push(st.units[i]);
            }
          }
          st.finalUnitArray = unitArr;

          st = {
            ...st,
            disciplineValue: {
              id: instr.ds_id,
              label: instr.ds_name,
            },
            instrumentNameId: instr.inst_instrumentName,
            calibrationProcedureNo: instr.inst_calibrationProcedureNo,
            referenceStandards: instr.inst_referenceStandards,
            subGroup: instr.inst_subGroup,
            tablePartition: instr.inst_tablePartition,
            formatNumber: instr.inst_formatNumber,
            revisionNumber: instr.inst_revisionNumber,
            remarkId: instr.inst_remarkId,
            revisionDate: instr.inst_revisionDate,
            sopUpload: instr.inst_sopUpload,
            updateEnableDisableO: gaugeArr.filter(
              (e) => instr.inst_isGauge == e.id
            )[0],
            supportiveIds: st.supportive.filter(
              (s) =>
                sim?.[0]?.includes(s.id) &&
                sim?.[1]?.includes(s.standardRangesId)
            ),
            standardMasterIdArray: instr.inst_uncertaintyFactors,
            datasheetFormatNumber: instr.inst_datasheetFormatNumber,
            DatasheetRevisionNumber: instr.inst_DatasheetRevisionNumber,
            DatasheetRevisionDate: instr.inst_DatasheetRevisionDate,
          };
        }
        setState({ ...st });
      })
      .catch((err) =>{
        console.log("data error : ", err);
      });
  };

  const getCmcReadings = () => {
    let fromDateSelected = newRenewalDate ? originalRange[originalRange.length-1]?.fromDate : selectedDateRange.selectedFrom;
    let toDateSelected = newRenewalDate ? originalRange[originalRange.length-1]?.toDate : selectedDateRange.selectedTo;

    let previousCMCReading = newRenewalDate ? "" : `LIMIT ${rowsPerPage} OFFSET ${page * rowsPerPage}`;

    let whereCondition = `WHERE instrumentId = ${params.id} AND accreditationType = ${accreditationType}`;  
    // Add date range filter if selected
    const { fromDate, toDate } = getFormattedDates(fromDateSelected, toDateSelected);    
    if (fromDateSelected && toDateSelected) {
      whereCondition += ` AND fromDate >= '${fromDate}' AND toDate <= '${toDate}'`;
    }  
    let query = {
      query: `SELECT * FROM cmc ${whereCondition} ${previousCMCReading}`
    };
    return axiosWithToken
      .post(BASE_URL + "dynamic", query)
      .then(async (res) => {
        const totalCountQuery = {
          query: `SELECT COUNT(*) AS no_of_rows FROM cmc ${whereCondition}`
        };
      const totalCountResponse = await axiosWithToken.post(BASE_URL + "dynamic", totalCountQuery);
      const totalCount = totalCountResponse.data[0]?.no_of_rows;
      setTotalRows(totalCount);
      if(!newRenewalDate){
      sessionStorage.setItem('cmcReadings', JSON.stringify(res.data));
      }
        return res.data;
      })
      .catch((err) => {
        retErr("Something Went Wrong while fetching standardRanges!", err);
        console.log("cmc data error : ", err);
      });
  };
 

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const fetchCMC = async () => {
      try {
        let res = await getCmcReadings();
        let cmcReadings = res;
        let rows = [];
        let rowsSpace = [];
        for (let i = 0; i < cmcReadings.length; i++) {
          rowsSpace.push([
            newRenewalDate ? "" : cmcReadings[i].id,
            "",
            "",
            "",
            (cmcReadings[i].fromRange || "#").split("#")[1],
            (cmcReadings[i].toRange || "#").split("#")[1],
            (cmcReadings[i].parameter || "#").split("#")[1],
            (cmcReadings[i].lowerCmc || "#").split("#")[1],
            (cmcReadings[i].higherCmc || "#").split("#")[1],
            cmcReadings[i].location,
            (cmcReadings[i].lc || "#").split("#")[1],
          ]);
          rows.push([
            newRenewalDate ? "" : cmcReadings[i].id,
            (cmcReadings[i].mode || "#").split("#")[0],
            (cmcReadings[i].etParameter || "#").split("#")[0],
            (cmcReadings[i].paratype || "#").split("#")[0],
            (cmcReadings[i].fromRange || "#").split("#")[0],
            (cmcReadings[i].toRange || "#").split("#")[0],
            (cmcReadings[i].parameter || "#").split("#")[0],
            (cmcReadings[i].lowerCmc || "#").split("#")[0],
            (cmcReadings[i].higherCmc || "#").split("#")[0],
            cmcReadings[i].location,
            (cmcReadings[i].lc || "#").split("#")[0],
            cmcReadings[i].fromDate,
            cmcReadings[i].toDate,
          ]);
        }
        
        setState2((prevState) => ({
          ...prevState,
          readingRows: rows,
          readingRangeValue: rowsSpace,
        }));
      } catch (error) {
        console.log(error);
      }
    };
    if(params.id){
      fetchCMC();
    }
  }, [accreditationType, selectedDateRange, rowsPerPage, page, newRenewalDate]);

  const updateRangeCellValue = (rowIndex, colIndex, value) => {
    value = typeof value == 'string' ? value.trim() : value;
    const newRows = [...state.readingRangeValue];
    newRows[rowIndex][colIndex] = value;
    if (colIndex === 4) {
      const shouldUpdateColumns = 
        newRows[rowIndex][5] === null ||
        newRows[rowIndex][7] === null ||
        newRows[rowIndex][8] === null ||
        newRows[rowIndex][10] === null;  
      if (shouldUpdateColumns) {
      newRows[rowIndex][5] = value;
      newRows[rowIndex][7] = value;
      newRows[rowIndex][8] = value;
      newRows[rowIndex][10] = value;
      }
    }
    setState({
      readingRangeValue: [...newRows],
    });
  };

  const updateCellValue = (rowIndex, colIndex, value) => {
    value = typeof value == 'string' ? value.trim() : value;
    const newRows = [...state.readingRows];
    newRows[rowIndex][colIndex] = value;
    setState({
      readingRows: [...newRows],
    });
  };
 
  const addDescriptionRow = (tableIndex) => {
    let newReadingRows = [...state.readingRows];
    if (tableIndex !== undefined) {
      newReadingRows.push([...state.readingRows[tableIndex]]);
      newReadingRows[newReadingRows.length - 1][0] = "";
    } else newReadingRows.push(["", "", "", "", "", "", "", "", "", "", "", "", ""]);

    let newReadingRowss = [...state.readingRangeValue];
    if (tableIndex !== undefined) {
      newReadingRowss.push([...state.readingRangeValue[tableIndex]]);
      newReadingRowss[newReadingRowss.length - 1][0] = "";
    }
    else newReadingRowss.push([null, null, null, null, null, null, null, null, null, null, null, null, null]);

    let st = {
      readingRows: [...newReadingRows],
      readingRangeValue: [...newReadingRowss],
    };
    setState({ ...st });
    setTotalRows(totalRows + 1);
    seEditingRowIndex(newReadingRows.length-1);
  };

  const deleteReadingRow = (rowIndex) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this row?");
    if (!isConfirmed) {
      return; 
    }
    let newReadingRows = [...state.readingRows];
    let newreadingRangeValue = [...state.readingRangeValue];
    const row = newReadingRows[rowIndex];
    if (!row) {
      return;
    }
    if (row[0]) {
          newReadingRows.splice(rowIndex, 1);
          newreadingRangeValue.splice(rowIndex, 1);
          setState({
            readingRows: [...newReadingRows],
            readingRangeValue: [...newreadingRangeValue],
          });
          setdelteRangesID([...delteRangesID, row[0]]);
          setTotalRows(totalRows - 1);
    } else {
      newReadingRows.splice(rowIndex, 1);
      newreadingRangeValue.splice(rowIndex, 1);
      setState({
        readingRows: [...newReadingRows],
        readingRangeValue: [...newreadingRangeValue],
      });
      setTotalRows(totalRows - 1);
    }
  };

  function getRemarksData() {
    let paylod = {
      query: `SELECT *  FROM remarks`,
    };
    axiosWithToken
      .post(BASE_URL + `dynamic`, paylod)
      .then((res) => {
        let newData = res.data;
        setRemarksData(newData);
      })
      .catch((err) => {
        console.log("remarks data fetching error: ", err);
      });
  }

  const [editingRowIndex, seEditingRowIndex] = React.useState(-1);

  const renderEditCMC = (index, row) => {
    return (
      <>
        {row.map((cell, cellIndex) => {
          if (
            cellIndex != 0 &&
            cellIndex != 1 &&
            cellIndex != 2 &&
            cellIndex != 3 &&
            cellIndex != 6 &&
            cellIndex != 8 &&
            cellIndex != 9
          ) {
            return (
              <TableCell>
                <TextField
                  id="instrumentlist_create_nablevalue"
                  size="small"
                  inputProps={{
                    autoComplete: 'off',
                  }}
                  value={cell}
                  onChange={(e) => {
                    updateCellValue(index, cellIndex, e.target.value);
                  }}
                ></TextField>
                <br />
                <select
                  id="instrumentlist_create_nablunit"
                  // disabled={plus}
                  styles={{ width: "100%" }}
                  onChange={(e) => {
                    updateRangeCellValue(index, cellIndex, e.target.value);
                  }}
                >
                  <option value={""} key={""} selected>
                    {""}
                  </option>
                  {state.finalUnitArray?.map((unit) => {
                    if (
                      unit.symbol == state.readingRangeValue[index][cellIndex]
                    ) {
                      return (
                        <option value={unit.symbol} key={unit.symbol} selected>
                          {unit.symbol}
                        </option>
                      );
                    } else {
                      return (
                        <option value={unit.symbol} key={unit.symbol}>
                          {unit.symbol}
                        </option>
                      );
                    }
                  })}
                </select>
              </TableCell>
            );
          }
          if (cellIndex == 1 && !state.et) {
            return (
              <TableCell>
                <Autocomplete
                  style={{ width: "150px" }}
                  size="small"
                  id="combo-box-demo"
                  value={cell}
                  options={mode.map((e) => ({
                    label: e,
                  }))}
                  renderInput={(params) => (
                    <TextField {...params} label="Mode *" />
                  )}
                  onInputChange={(event, newInputValue) => {
                    const isValid = mode?.some(option => option === newInputValue);
                    updateCellValue(index, cellIndex, isValid ? newInputValue : null);
                  }}
                  // disabled={plus}
                />
                <select
                  disabled={true}
                  styles={{ width: "100%" }}
                  onChange={(e) => {
                    updateRangeCellValue(index, cellIndex, e.target.value);
                  }}
                >
                  <option value={""} key={""} selected>
                    {""}
                  </option>
                  {state.finalUnitArray?.map((unit) => {
                    if (
                      unit.symbol == state.readingRangeValue[index][cellIndex]
                    ) {
                      return (
                        <option value={unit.symbol} key={unit.symbol} selected>
                          {unit.symbol}
                        </option>
                      );
                    } else {
                      return (
                        <option value={unit.symbol} key={unit.symbol}>
                          {unit.symbol}
                        </option>
                      );
                    }
                  })}
                </select>
              </TableCell>
            );
          }
          if (cellIndex == 2 && !state.et) {
            return (
              <TableCell>
                <Autocomplete
                  style={{ width: "250px" }}
                  size="small"
                  id="combo-box-demo"
                  value={cell}
                  options={
                    parameters[row[1]]
                      ? parameters[row[1]].map((e) => ({
                          label: e,
                        }))
                      : []
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Parameter *" />
                  )}
                  onInputChange={(event, newInputValue) => {
                    const isValid = parameters[row[1]]?.some(option => option === newInputValue);
                      updateCellValue(index, cellIndex, isValid ? newInputValue : "");
                  }}
                  // disabled={(plus || !row[2]) ? true : false}
                  disabled={!row[1] ? true : false}
                />
                <select
                  disabled={true}
                  styles={{ width: "100%" }}
                  onChange={(e) => {
                    updateRangeCellValue(index, cellIndex, e.target.value);
                  }}
                >
                  <option value={""} key={""} selected>
                    {""}
                  </option>
                  {state.finalUnitArray?.map((unit) => {
                    if (
                      unit.symbol == state.readingRangeValue[index][cellIndex]
                    ) {
                      return (
                        <option value={unit.symbol} key={unit.symbol} selected>
                          {unit.symbol}
                        </option>
                      );
                    } else {
                      return (
                        <option value={unit.symbol} key={unit.symbol}>
                          {unit.symbol}
                        </option>
                      );
                    }
                  })}
                </select>
              </TableCell>
            );
          }
          if (cellIndex == 3 && !state.et) {
            return (
              <TableCell>
                {!(paratype[row[1]] && paratype[row[1]][row[2]]) ? (
                  <TextField
                    size="small"
                    inputProps={{
                      autoComplete: 'off',
                    }}
                    value={cell}
                    onChange={(e) => {
                      updateCellValue(index, cellIndex, e.target.value);
                    }}
                    disabled={!row[2]}
                  ></TextField>
                ) : (
                  <Autocomplete
                    style={{ width: "150px" }}
                    size="small"
                    id="combo-box-demo"
                    value={cell}
                    options={
                      paratype[row[1]] && paratype[row[1]][row[2]]
                        ? paratype[row[1]][row[2]].map((e) => ({
                            label: e,
                          }))
                        : []
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Parameter Type *" />
                    )}
                    onInputChange={(event, newInputValue) => {
                      const isValid = paratype[row[1]][row[2]]?.some(option => option === newInputValue);
                      updateCellValue(index, cellIndex, isValid ? newInputValue : "");
                    }}
                    // disabled={
                    //   plus ||
                    //   !(paratype[row[3]] && paratype[row[3]][row[4]])
                    //     ? true
                    //     : false
                    // }
                  />
                )}
                <select
                  id="instrumentlist_create_nablunit"
                  disabled={true}
                  styles={{ width: "100%" }}
                  onChange={(e) => {
                    updateRangeCellValue(index, cellIndex, e.target.value);
                  }}
                >
                  <option value={""} key={""} selected>
                    {""}
                  </option>
                  {state.finalUnitArray?.map((unit) => {
                    if (
                      unit.symbol == state.readingRangeValue[index][cellIndex]
                    ) {
                      return (
                        <option value={unit.symbol} key={unit.symbol} selected>
                          {unit.symbol}
                        </option>
                      );
                    } else {
                      return (
                        <option value={unit.symbol} key={unit.symbol}>
                          {unit.symbol}
                        </option>
                      );
                    }
                  })}
                </select>
              </TableCell>
            );
          }
          if (cellIndex == 8) {
            const isError = Number(cell) < Number(row[7]) && cell !== "";
            return (
              <TableCell>
                <TextField
                  size="small"
                  error={isError}
                  helperText={isError ? "Value must be greater than or equal to lower CMC" : ""}
                  inputProps={{ autoComplete: "off" }}
                  value={cell}
                  onChange={(e) => {
                    updateCellValue(index, cellIndex, e.target.value);
                  }}
                />
                <br />
                <select
                  id="instrumentlist_create_nablunit"
                  // disabled={plus}
                  styles={{ width: "100%" }}
                  onChange={(e) => {
                    updateRangeCellValue(index, cellIndex, e.target.value);
                  }}
                >
                  <option value={""} key={""} selected>
                    {""}
                  </option>
                  {state.finalUnitArray?.map((unit) => {
                    if (
                      unit.symbol == state.readingRangeValue[index][cellIndex]
                    ) {
                      return (
                        <option value={unit.symbol} key={unit.symbol} selected>
                          {unit.symbol}
                        </option>
                      );
                    } else {
                      return (
                        <option value={unit.symbol} key={unit.symbol}>
                          {unit.symbol}
                        </option>
                      );
                    }
                  })}
                </select>
              </TableCell>
            );
          }          
          if (cellIndex == 9) {
            return (
              <TableCell>
                <Autocomplete
                  style={{ width: "150px" }}
                  size="small"
                  id="combo-box-demo"
                  value={cell !== "" ? { label: cell === 1 ? 'In House' : 'Onsite', value: cell } : { label: 'In House', value: 1 }}
                  options={[
                    { label: "In House", value: 1 },
                    { label: "Onsite", value: 2 },
                  ]}
                  renderInput={(params) => (
                    <TextField {...params} label="Location" />
                  )}
                  onChange={(event, newValue) => {
                    updateCellValue(index, cellIndex, newValue ? newValue.value : 1);
                  }}
                  // disabled={plus}
                />
                <select
                  disabled={true}
                  styles={{ width: "100%" }}
                  onChange={(e) => {
                    updateRangeCellValue(index, cellIndex, e.target.value);
                  }}
                >
                  <option value={""} key={""} selected>
                    {""}
                  </option>
                  {state.finalUnitArray?.map((unit) => {
                    if (
                      unit.symbol == state.readingRangeValue[index][cellIndex]
                    ) {
                      return (
                        <option value={unit.symbol} key={unit.symbol} selected>
                          {unit.symbol}
                        </option>
                      );
                    } else {
                      return (
                        <option value={unit.symbol} key={unit.symbol}>
                          {unit.symbol}
                        </option>
                      );
                    }
                  })}
                </select>
              </TableCell>
            );
          }
          if (cellIndex == 6 && state.et) {
            return (
              <TableCell>
                <Autocomplete
                  style={{ width: "150px" }}
                  size="small"
                  id="combo-box-demo"
                  value={cell}
                  options={otherParamter}
                  renderInput={(params) => (
                    <TextField {...params} label="Parameter" />
                  )}
                  onInputChange={(event, newInputValue) => {
                    const isValid = otherParamter?.some(option => option.label === newInputValue);
                    updateCellValue(index, cellIndex, isValid ? newInputValue : null);
                  }}
                />
                <select
                  disabled={true}
                  styles={{ width: "100%" }}
                  onChange={(e) => {
                    updateRangeCellValue(index, cellIndex, e.target.value);
                  }}
                >
                  <option value={""} key={""} selected>
                    {""}
                  </option>
                  {state.finalUnitArray?.map((unit) => {
                    if (
                      unit.symbol == state.readingRangeValue[index][cellIndex]
                    ) {
                      return (
                        <option value={unit.symbol} key={unit.symbol} selected>
                          {unit.symbol}
                        </option>
                      );
                    } else {
                      return (
                        <option value={unit.symbol} key={unit.symbol}>
                          {unit.symbol}
                        </option>
                      );
                    }
                  })}
                </select>
              </TableCell>
            );
          }
        })}
      </>
    );
  };

  const renderViewCMC = (index, row) => {
    return (
      <>
        {row.map((cell, cellIndex) => {
          if (
            cellIndex != 0 &&
            cellIndex != 1 &&
            cellIndex != 2 &&
            cellIndex != 3 &&
            cellIndex != 6 &&
            cellIndex != 9
          ) {
            return (
              <TableCell
                onClick={() => {
                  seEditingRowIndex(index);
                }}
              >
                <Typography noWrap>
                  <span>
                    {cell ? `${cell} ` : ""}
                  </span>
                  <span>
                    {
                      state.finalUnitArray?.find(
                        (unit) =>
                          unit.symbol === state.readingRangeValue[index][cellIndex]
                      )?.symbol
                    }
                  </span>
                </Typography>
              </TableCell>
            );
          }
          if ((cellIndex == 1 && !state.et) || (cellIndex == 2 && !state.et) || (cellIndex == 3 && !state.et)) {
            return (
              <TableCell
                onClick={() => {
                  seEditingRowIndex(index);
                }}
              >
                <Typography noWrap>
                  <span>{cell ? `${cell}` : ""}</span>
                  {
                      state.finalUnitArray?.find(
                        (unit) =>
                          unit.symbol === state.readingRangeValue[index][cellIndex]
                      )?.symbol
                    }
                </Typography>
              </TableCell>
            );
          }
          if (cellIndex == 9) {
            return (
              <TableCell
                onClick={() => {
                  seEditingRowIndex(index);
                }}
              >
                <Typography noWrap>
                  <span>{cell ? `${cell == 1 ? "In House" : "Onsite"}` : ""}</span>
                </Typography>
              </TableCell>
            );
          }
          if (cellIndex == 6 && state.et) {
            return (
              <TableCell
                onClick={() => {
                  seEditingRowIndex(index);
                }}
              >
                <Typography noWrap>
                  <span>{cell ? `${cell}` : ""}</span>
                  {
                      state.finalUnitArray?.find(
                        (unit) =>
                          unit.symbol === state.readingRangeValue[index][cellIndex]
                      )?.symbol
                    }
                </Typography>
              </TableCell>
            );
          }
        })}
      </>
    );
  };

  const renderTableBody = () => {
    return (
      <TableBody>
        {state.readingRows
          ?.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <Box sx={{ display: "flex", gap: "10px" }}>
                  <IconButton
                    id="instrumentlist_create_copynabl"
                  disabled={!(editAccess?.includes(5) || editAccess?.includes(0)) || disabledButtonDue}
                    style={{ cursor: "pointer", color:!(editAccess?.includes(5) || editAccess?.includes(0)) || disabledButtonDue ? 'lightgray' : '#1976d2', padding: "0px" }}
                    onClick={(e) => {
                      if (!(editAccess?.includes(5) || editAccess?.includes(0))) {
                        return;
                      }
                      addDescriptionRow(index);
                    }}
                  >
                  <ContentCopyIcon />
                </IconButton>
                <IconButton
                    id="instrumentlist_create_nabl_delete"
                  disabled={!(editAccess?.includes(2) || editAccess?.includes(0))}
                  style={{ cursor: "pointer", color:!(editAccess?.includes(2) || editAccess?.includes(0)) ? 'lightgray' : '#dc3545', padding: "0px" }}
                    onClick={(e) => {
                      if (!(editAccess?.includes(2) || editAccess?.includes(0))) {
                        return;
                      }
                      deleteReadingRow(index);
                    }}
                >
                  <DeleteIcon />
                </IconButton>
                </Box>
              </TableCell>
              <TableCell>{index + 1}</TableCell>
              {editingRowIndex == index && renderEditCMC(index, row.slice(0, -2))}
              {editingRowIndex !== index &&
                renderViewCMC(index, row.slice(0, -2))}
            </TableRow>
          ))}
      </TableBody>
    );
  };

  useEffect(() => {
    if (params.id) {
      let newFilterStandards = filterStandardsByDiscipline(
        state?.standards,
        state?.disciplineValue?.id
      );
      setState2((prevState) => ({
        ...prevState,
        filteredStandards: newFilterStandards,
      }));
    }
  }, [state?.disciplineValue?.id]);

  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const AllSettings = await allSettings();
        let filterAccreditationType = AllSettings?.find(
          (ele) => ele.keyName == "accreditationType"
        )?.value?.split(",");
        const filteredOptions = filterAccreditationType.map((label, index) => ({
          id: index + 1,
          label: label.trim(),
        }));
        setAccreditationOptions(filteredOptions);
        let tablePartitionFetch = AllSettings?.find(
          (ele) => ele.keyName == "TablePartition"
        )?.value;
        settablePartitionSetting(tablePartitionFetch);
        const sopUploadSetting =  AllSettings?.find(
          (ele) => ele.keyName == "SOPUpload"
        )?.value === "true";
        setIssopUpload(sopUploadSetting);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSetting();
  }, []);

useEffect(()=>{
  getRemarksData();
},[]);

useEffect(async () => {
  if (params.id) {
    const distinctRange = await getDateDistinct(params.id);
    setDateRange(distinctRange);
    setOriginalRange(distinctRange);
    setSelectedDateRange({
     selectedFrom:  moment(distinctRange?.[0]?.fromDate).format("YYYY-MM-DD"),
     selectedTo:  moment(distinctRange?.[0]?.toDate).format("YYYY-MM-DD"),
   });
  }
  }, [params.id]);


useEffect(() => {
  if (scrollTo) {
    setTimeout(() => {
      // Scroll to the bottom of the container if it exists
      if (containerRef.current) {
        containerRef.current.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }
    }, 5000); // Adding timeout to ensure the page loads first
  }
}, [scrollTo]);

  return (
    <EditWrap>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6" component="h6" style={{ float: "left" }}>
          Create new instrument
        </Typography>
        <Tooltip title="User Guide" placement="top-start">
          <Button
            onClick={() => {
              createInstrumentGuides.drive();
            }}
          >
            <HelpIcon />
          </Button>
        </Tooltip>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6} md={4} lg={3}>
          <Autocomplete
            disabled={!isNaN(Number(params.id))}
            size="small"
            id="instrumentlist_create_discipline"
            options={[...state.disciplineArr]}
            renderInput={(params) => (
              <TextField {...params} label="Discipline *" />
            )}
            defaultValue={undefined}
            value={state.disciplineValue || {}}
            getOptionLabel={(option) => option.label || ""}
            onChange={(event, value) => {
              let st = {};
              if (value != null) {
                let disciplineKeys = false;
                state.disciplines.forEach((el) => {
                  if (el.id == value.id) {
                    if (el.disciplineKey == "0") {
                      disciplineKeys = true;
                    }
                  }
                });
                if (disciplineKeys) {
                  st.et = false;
                } else {
                  st.et = true;
                }
                const unitArr = [""];
                for (let i = 0; i < state.units.length; i++) {
                  if (parseInt(value.id) == state.units[i].disciplineId) {
                    unitArr.push(state.units[i]);
                  }
                }
                st.finalUnitArray = unitArr;
                st.disciplineId = value.id;
                st.filteredStandards = filterStandardsByDiscipline(
                  state.standards,
                  value.id
                );
              } else {
                st.disciplineId = null;
              }
              st.disciplineValue = value;
              setState({ ...st });
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={3}>
          <TextField
            id="instrumentlist_create_instrumentname"
            label="Instrument name *"
            size="small"
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
            variant="outlined"
            value={state.instrumentNameId || ""}
            onChange={(e) => {
              setState({
                instrumentNameId: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={3}>
          <TextField
            id="instrumentlist_create_calibproced"
            label="Calibration Procedure No."
            size="small"
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
            variant="outlined"
            value={state.calibrationProcedureNo || ""}
            onChange={(e) => {
              setState({
                calibrationProcedureNo: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={3}>
          <TextField
            id="instrumentlist_create_master_issdtandards"
            label="Is Standards"
            size="small"
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
            variant="outlined"
            value={state.referenceStandards || ""}
            onChange={(e) => {
              setState({
                referenceStandards: e.target.value,
              });
            }}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3}>
          <TextField
            id="instrumentlist_create_master_issdtandards"
            label="Sub-Group"
            size="small"
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
            variant="outlined"
            value={state.subGroup || ""}
            onChange={(e) => {
              setState({
                subGroup: e.target.value,
              });
            }}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3}>
          <Autocomplete
            size="small"
            id="instrumentlist_create_gauage"
            onChange={(_, val) => {
              setState({
                updateEnableDisableO: val,
              });
            }}
            value={state.updateEnableDisableO}
            options={gaugeArr}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => <TextField {...params} label="Gauge" />}
          />
        </Grid>
        <Grid  
         item
         xs={6}
         sm={6}
         md={4}
         lg={3}
        >
          <Autocomplete
            size="small"
            id="combo-box-demo"
            options={remarksData}
            getOptionLabel={(option) => option.label}
            value={
                  remarksData.find(
                    (lab) =>
                      lab.id ===
                      state?.remarkId
                  ) || null
            }
                renderInput={(params) => (
                  <TextField {...params} label="Remark" />
                )}
            onChange={(event, value) => {
              if (value) {
                setState({
                  remarkId: value?.id,
                });
              } else {
                setState({
                      remarkId:null,
                });
              }
            }}
          />
        </Grid>
        {tablePartitionSetting == "true" ? (
          <Grid
            item
            xs={6}
            sm={6}
            md={4}
            lg={3}
            style={{ alignItems: "start" }}
          >
            <FormControlLabel
              classes={{
                alignItems: "left",
              }}
              style={{ display: "flex" }}
              control={
                <Checkbox
                  checked={state.tablePartition == 1}
                  onChange={(e) => {
                    setState({
                      tablePartition: e.target.checked ? 1 : 0,
                    });
                  }}
                />
              }
              label="Table Partition"
            />
          </Grid>
        ) : null}

        {ISsopUpload && (
          <>
            {state.sopUpload && (
              <Grid item xs={6} sm={6} md={4} lg={1}>
                <b style={{ width: "50%", m: "auto" }}>
                  <a
                    href={state.sopUpload}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View File
                  </a>
                </b>
              </Grid>
            )}
            <Grid item xs={6} sm={6} md={4} lg={2}>
              <Button
                id="create_document_uploadfile"
                component="label"
                size="small"
                variant="contained"
                startIcon={<CloudUploadIcon />}
                sx={{ width: "100%", m: "auto" }}
              >
                Upload File
                <VisuallyHiddenInput type="file" onChange={handleFileUpload} accept=".jpg,.jpeg,.png,.pdf" />
              </Button>
            </Grid>
          </>
        )}
      </Grid>
      <hr />
      <Typography variant="h6" component="h6" style={{ float: "left" }}>
        Certificate Document Details
        </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6} md={4} lg={3}>
          <TextField
            id="instrumentlist_create_formateno"
            label="Format Number"
            size="small"
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
            variant="outlined"
            value={state.formatNumber || ""}
            onChange={(e) => {
              setState({
                formatNumber: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={3}>
          <TextField
            id="instrumentlist_create_reviosno"
            label="Revision Number"
            size="small"
            inputProps={{
              autoComplete: 'off',
            }}
            fullWidth
            variant="outlined"
            value={state.revisionNumber || ""}
            onChange={(e) => {
              setState({
                revisionNumber: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid
          item
          xs={6}
          sm={6}
          md={4}
          lg={3}
          id="instrumentlist_create_revisondate"
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="Revision Date"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              value={state.revisionDate ? new Date(state.revisionDate) : ""}
              onChange={(newValue) => {
                setState({
                  revisionDate: newValue,
                });
              }}
              // onChange={(newValue) => {
              //   updateQuoObject("revisionDate", newValue);
              // }}
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>      
      <hr />
      <Typography variant="h6" component="h6" style={{ float: "left" }}>
        Datasheet Document Details
        </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6} md={4} lg={3}>
          <TextField
            label="Format Number"
            size="small"
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
            variant="outlined"
            value={state.datasheetFormatNumber || ""}
            onChange={(e) => {
              setState({
                datasheetFormatNumber: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={3}>
          <TextField
            label="Revision Number"
            size="small"
            inputProps={{
              autoComplete: 'off',
            }}
            fullWidth
            variant="outlined"
            value={state.DatasheetRevisionNumber || ""}
            onChange={(e) => {
              setState({
                DatasheetRevisionNumber: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid
          item
          xs={6}
          sm={6}
          md={4}
          lg={3}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="Revision Date"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              value={state.DatasheetRevisionDate ? new Date(state.DatasheetRevisionDate) : ""}
              onChange={(newValue) => {
                setState({
                  DatasheetRevisionDate: newValue,
                });
              }}
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <hr />
      <br/>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DisplayTable
            value={state.standardMasterIdArray}
            filteredStandards={state.filteredStandards}
            allStandards={state.standards}
            uncertaintyMasterData={state.uncertaintyMasterData}
            disciplineId={state.disciplineId}
            setState={setState}
            commonUncertaintyFactors={commonUncertaintyFactors}
            setCommonUncertaintyFactors={setCommonUncertaintyFactors}
          />
          {/* } */}
        </Grid>
      </Grid>

      <hr />
      <h4 style={{ "marginBottom": "5px" }}>Calibration Measurement Capability(CMC)</h4>
      <Grid container spacing={2}>
      <Grid item xs={6} sm={3} md={3} lg={2.5}>
        <Autocomplete
          key={accreditationOptions.length}
          options={accreditationOptions}
          size="small"
          getOptionLabel={(option) => option.label}
          value={accreditationOptions?.find(
            (ele) => ele.id === accreditationType
          )}
          onChange={(event, selectedOption) => {
            setAccreditationType(selectedOption ? selectedOption.id : 1);
            setSelectedDateRange({
              selectedFrom: '',
              selectedTo: '',
            });            
          }}
          renderInput={(params) => (
            <TextField {...params} label="Accreditation Type" />
          )}
        />
        </Grid>
      
        {renewalNewDate && (
          <>
        <Grid item xs={6} sm={3} md={3} lg={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="From Date"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              value={selectedDateRange?.selectedFrom ? new Date(selectedDateRange?.selectedFrom) : ""}
              onChange={(newValue) => {
                setSelectedDateRange((prev) => ({
                  ...prev,
                  selectedFrom: moment(newValue).format("YYYY-MM-DD"),
                }));
              }}
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
          </Grid>
        <Grid item xs={6} sm={3} md={3} lg={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="To Date"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              value={selectedDateRange?.selectedTo ? new Date(selectedDateRange?.selectedTo) : ""}
              onChange={(newValue) => {
                setSelectedDateRange((prev) => ({
                  ...prev,
                  selectedTo: moment(newValue).format("YYYY-MM-DD"),
                }));
              }}
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
          </Grid>
          </>
        )}

       {!renewalNewDate && (selectedDateRange?.selectedFrom && selectedDateRange?.selectedTo) && (
        <Grid item xs={6} sm={3} md={3} lg={2.8}>
        <Autocomplete
          options={dateRange}
          size="small"
          getOptionLabel={(option) => {
            const from = option?.fromDate ? moment(option?.fromDate).format('DD-MM-YYYY') : '';
            const to = option?.toDate ? moment(option?.toDate).format('DD-MM-YYYY') : '';
            return from && to ? `${from} to ${to}` : "";
          }}
          value={dateRange?.find(
            (option) =>
              moment(option?.fromDate).format("YYYY-MM-DD") == selectedDateRange?.selectedFrom &&
              moment(option?.toDate).format("YYYY-MM-DD") == selectedDateRange?.selectedTo
          ) || ""}
          onChange={(event, selectedOption) => {
            setnewRenewalDate(false);
            if (selectedOption) {
              setSelectedDateRange({
                selectedFrom:  moment(selectedOption?.fromDate).format("YYYY-MM-DD"),
                selectedTo:  moment(selectedOption?.toDate).format("YYYY-MM-DD"),
              });
            } else {
              setSelectedDateRange({
                selectedFrom: '',
                selectedTo: '',
              });
            }
          }}
          renderInput={(params) => (
            <TextField {...params} label="Date Range" />
          )}
        />
        </Grid>
       )}

        <Grid item xs={6} sm={3} md={3} lg={2.5}>
        <Button
          // startIcon={<AddIcon />}
          // disabled={!selectedDateRange?.selectedFrom && !selectedDateRange?.selectedTo}
          onClick={(e) => {
            let st = {
              readingRows: [],
              readingRangeValue: [],
            };
            if(!renewalNewDate){
              setRenewalDate(true);
              setSelectedDateRange({
                selectedFrom: "",
                selectedTo: "",
              });
            } else {
              setState({ ...st });
              setTotalRows(0);
              if(selectedDateRange?.selectedFrom && selectedDateRange?.selectedTo){
                setDateRange((prev) => [
                  ...(prev || []),
                  {
                    fromDate: selectedDateRange?.selectedFrom,
                    toDate: selectedDateRange?.selectedTo,
                  },
                ]);
              }
              setRenewalDate(false);
              setnewRenewalDate(true);
            }
          }}
          variant="contained"
          size="small"
        >
          {renewalNewDate ? "Add" : "Add New Scope Range"}    
          </Button>
        </Grid>

        <Grid item xs={6} sm={3} md={3} lg={2}>
        <Button
          id="instrumentlist_create_addnablscope"
          startIcon={<AddIcon />}
          onClick={(e) => {
            addDescriptionRow();
          }}
          variant="contained"
          size="small"
          disabled={!(selectedDateRange?.selectedFrom && selectedDateRange?.selectedTo) || disabledButtonDue}
        >
          Add CMC
        </Button>
      </Grid>
      </Grid>
      <br/>

      <div
        style={{ width: "100%", overflow: "auto" }}
        id="instrumentlist_create_nablscope"
      >
        <ClassicTable>
        <TableContainer sx={{ maxHeight: 500 }}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                {state.readingColumns[0]
                  // .filter((e) => e.toggle === undefined || !state.et)
                  .filter((e) => (e.field !== "parameter" || state.et) && (e.toggle === undefined || !state.et))
                  .map((column) => (
                    <TableCell key={column.field}>
                      {" "}
                      <Typography noWrap>{column.headerName}</Typography>
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>
            {renderTableBody()}
          </Table>
          </TableContainer>
        </ClassicTable>
          <TablePagination
            rowsPerPageOptions={[5, 10, 30, 50]}
            component="div"
            count={totalRows}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
      </div>

      <br />
      <Toolbar
        style={{
          padding: "0px",
          overflow: "auto",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          marginTop: "3rem",
        }}
        ref={containerRef} 
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "grey" }}
          size="small"
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        >
          Cancel
        </Button>
        <Tooltip title={!(editAccess?.includes(1) || editAccess?.includes(0)) ? "You don't have access" : ''}>
        <Button
          id="instrumentlist_create_save"
          variant="contained"
          size="small"
          sx={{ m: 0 }}          
           disabled={!(editAccess?.includes(1) || editAccess?.includes(0)) || scrollTo == "bottom" || disabledButtonDue}
          onClick={(e) => {
            if (params.id === undefined) {
              if (!state.disciplineValue.id) {
                toast.error('Please select a Discipline');
                return;
              }
              if (!state.instrumentNameId) {
                toast.error('Instrument Name is required');
                return;
              }
              if (!state.calibrationProcedureNo) {
                toast.error('Calibration Procedure No is required');
                return;
              }
            }
            onSubmit(params, state, accreditationType, selectedDateRange, delteRangesID, commonUncertaintyFactors);
          }}
        >
          {params.id ? "Update" : "Save"}
        </Button>
        </Tooltip>
      </Toolbar>
      {/* <ToastContainer /> */}
      {errormodalIsOpen && <ErrorModal errormodalIsOpen={errormodalIsOpen} closeErrorModal={closeErrorModal} errorMessage={errorMessage} />}
    </EditWrap>
  );
};

export default CreateInstrument;
